import {InitPage} from "../index";
import swal from "sweetalert";
import Swal from 'sweetalert2'


class DeleteDialog {
    constructor() {
        const _this = this;
        $(".deleteRecordDialog").on("click", function(){
            let deleteMessage = "This operation will delete the row logically";
            let deleteTitle   = "Are you sure?";
            const _anchor = this;
            if (typeof $(_anchor).data("delete-message") !== "undefined") {
                deleteMessage = $(_anchor).data("delete-message");
            }
            if (typeof $(_anchor).data("delete-title") !== "undefined") {
                deleteTitle = $(_anchor).data("delete-title");
            }
            _this.confirm_delete($(_anchor).data("delete-path"), deleteTitle, deleteMessage);
        });

        $('body').on('click', '.deleteRecord', function(e) {
          const next = $(e.currentTarget).next();
          var message = $(this).attr('data-delete-message');
                  swal({
                    title: 'Are you sure?',
                    text:  message,
                    icon: "warning",
                    closeOnClickOutside: false,
                    buttons: {
                      cancel: {
                        text: "No",
                        value: null,
                        visible: true,
                        className: "sn-btn sn-btn-sm sn-btn-silver",
                        closeModal: true
                      },
                      confirm: {
                        text: "Yes",
                        value: true,
                        visible: true,
                        className: "sn-btn sn-btn-sm sn-btn-red",
                        closeModal: true
                      }
                    },
                    dangerMode: true,
                  }).then((willDelete) => {
                    if (willDelete) {
                      next.click();
                    } else {
                      return false;
                    }
                  });
              });

      $('.delete-record').on('click', function(e) {
        const trigger = $(e.currentTarget);
        if (trigger.data('delete-in-progress')) {
          return;
        }

        const html = trigger.attr('data-delete-html');
        // @ts-ignore
        Swal.fire({
          title: 'Are you sure?',
          html,
          icon: "warning",
          closeOnClickOutside: false,
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: `Yes`,
          confirmButtonColor: '#c0392b',
          cancelButtonText: `No`,
          cancelButtonColor: '#bdc3c7',
        }).then((result) => {
          if (result.isConfirmed) {
            trigger.data('delete-in-progress', true).prop('disabled', true);
            var target = trigger.next();
            target.off('click').css('pointer-events', 'none');
            target.get(0).click();
          } else {
            return false;
          }
        });
      })
    }

    confirm_delete(deletePath, deleteTitle, deleteMessage) {
        swal({
          title: deleteTitle,
          text:  deleteMessage,
          icon: "warning",
          closeOnClickOutside: false,
          buttons: {
            cancel: {
              text: "No",
              value: null,
              visible: true,
              className: "sn-btn sn-btn-sm sn-btn-silver",
              closeModal: true
            },
            confirm: {
              text: "Yes",
              value: true,
              visible: true,
              className: "sn-btn sn-btn-sm sn-btn-red",
              closeModal: true
            }
          },
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            $.ajax({
              type: "DELETE",
              url: deletePath
            });
          } else {
            return false;
          }
        });
      }

}

export function LoadPage() {
    const delete_dialog = new DeleteDialog();
}

